import { render, staticRenderFns } from "./UserCreateOrUpdate.vue?vue&type=template&id=cf556c94&"
import script from "./UserCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./UserCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports